var KitchenOrderItem = /** @class */ (function () {
    function KitchenOrderItem() {
        this.printQueue = {};
        this.dualReceipt = false;
        this.showNo = false;
        this.callNo = null;
    }
    return KitchenOrderItem;
}());
export { KitchenOrderItem };
//# sourceMappingURL=kitchen-order-item.js.map